import axios from 'axios';
import * as qs from 'app/lib/helperjs';
import {
    DATA_FORM_EVENT_NAME,
    preventResendingForm, alert
} from './formDataHandler';

export const SetPasswordForm = () => {
    const setPasswordForm = qs.querySelector('[data-form="set_password"]');
    if (!setPasswordForm) {
        return;
    }
    const customerNumber = setPasswordForm.querySelector('.customer-number').value;
    const resetHash = setPasswordForm.querySelector('.reset-hash').value;
    const passwordInput = setPasswordForm.querySelector('input#new_password');
    const submitButton = setPasswordForm.querySelector('.set-password-submit');

    const fetchEmail = () => {
        const url = setPasswordForm.getAttribute('data-mail-resolve-endpoint');

        axios.get(url, {
            params: {
                client_number: customerNumber,
                hash: resetHash
            }
        }).then((response) => {
            if (response.status === 200 && response.data) {
                setPasswordForm.querySelector('.user-id-box').innerText = response.data;
            }
        })
    };

    const lockSetPasswordForm = () => {
        submitButton.disabled = true;
        passwordInput.readOnly = true;
    };

    const validatePassword = () => {
        const passwordMinLen = parseInt(passwordInput.getAttribute('data-min-length'));

        if (passwordInput.value.length < passwordMinLen) {
            setPasswordForm.querySelector('.new_password_invalid_length').style.display = 'block';

            return false;
        }

        return true;
    };

    fetchEmail();

    passwordInput.onkeydown = () => setPasswordForm.querySelector('.new_password_invalid_length').style.display = 'none';
    passwordInput.onblur = () => validatePassword();
    document.addEventListener(DATA_FORM_EVENT_NAME, function listener(evt) {
        const {data, url, form} = evt.detail;

        if (!setPasswordForm.isEqualNode(form)) {
            return;
        }

        if (!validatePassword()) {
            return;
        }

        axios.post(url, data)
            .then(() => alert('success'))
            .then(() => preventResendingForm(form))
            .then(() => lockSetPasswordForm())
            .then(() => document.removeEventListener(DATA_FORM_EVENT_NAME, listener, true))
            .catch(() => alert('failure'));
    }, true);
};
